import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TableRow, Switch, Box, Paper, IconButton, TablePagination } from "@material-ui/core";
import { styled } from '@mui/material/styles';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useQuery } from 'react-query';
import { SUBSCRIBER_API_URL } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import EditPenIcon from 'src/svgComponents/EditPenIcon'
import Stack from '@mui/material/Stack';
import { Button, Modal, TextField, InputBase } from "@mui/material";
import { useNavigate } from "react-router";
import SearchIcon from "src/svgComponents/SearchIcon";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment'
import LoadingScreen from 'src/components/LoadingScreen'
import useStore from 'src/contexts/AuthProvider'
import AppTooltip from "src/components/common/AppTooltip";
import { Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
const _ = require('lodash');

export default function SubscriberList() {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('createdAt');
    const [filterName, setFilterName] = useState('');
    const axiosPrivate = useAxiosPrivate();
    const [loding, setLoding] = useState(true);
    const theme = useTheme();

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    const TABLE_HEAD = [
        { id: 'email', label: 'Email', alignRight: false },
        { id: 'createdAt', label: 'Date', alignRight: false },
        // { id: 'status', label: 'Status', alignRight: false },
        // { id: 'action', label: 'Action', alignRight: false },
    ];

    async function getSupportSubjectData(page, filterName) {
        const response = await axiosPrivate.get(SUBSCRIBER_API_URL.subscriberList, { params: { page: page + 1, limit: rowsPerPage, search: filterName } });
        return response.data[0];
    }
    const { isLoading, data: subjectData, refetch } = useQuery(['subjectData', page, filterName], () => getSupportSubjectData(page, filterName), { keepPreviousData: true, })

    useEffect(() => {

        if (subjectData) {
            // console.log("permision data use effect")
            setTableData(subjectData.data);
            setRowsPerPage(subjectData?.metadata.length != 0 ? subjectData?.metadata[0].limit : 10);
            setRowsPerPage(10);
        }
        setTimeout(() => {
            setLoding(false);
        }, 200);
    }, [subjectData])

    const handleFilterByName = (event) => {
        setFilterName(event.target.value.trim());
        getSupportSubjectData(page, filterName);
    };


    const filteredUsers = tableData;
    const isUserNotFound = filteredUsers?.length === 0;
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
  
    if (isLoading) return <LoadingScreen />

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTimeout(() => {
            refetch();
        }, 500);
    };

    return (
        <>
            {/* {loding ? <LoadingScreen /> : <>
      }
    </> */}
            <div className="dashboard_header mb-4">
                <h5 className="card-header">Subscriber List</h5>

                <Paper component="form" className='dashboard_searchbox col-lg-4'>
                    <IconButton>
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        fullWidth
                        sx={{ flex: 1 }}
                        placeholder="Search Subscriber..."
                        onChange={(e) => handleFilterByName(e)}
                        onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                    />
                </Paper>
            </div>
            <Card>
                <TableContainer>
                    <Table>
                        <UserListHead
                            headLabel={TABLE_HEAD}
                            rowCount={subjectData?.data?.length}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {tableData.length != 0 && tableData?.map((row) => {
                                return (
                                    <StyledTableRow key={row?._id}>
                                        <TableCell component="th" scope="row">
                                            {row?.email}
                                        </TableCell>
                                        <TableCell align="left"> {moment(row?.createdAt).format("MMM DD YYYY h:mm A")}
                                        </TableCell>
                                    </StyledTableRow>
                                )
                            })}

                        </TableBody>

                        {isUserNotFound && (
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                                        <span className="app_text_16_semibold">No Data Found</span>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    count={subjectData?.metadata.length != 0 ? subjectData?.metadata[0].total : 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
          
        </>
    )
}

